import axios from "axios"

export function getAllQuestions(){
    return axios.request({
        method:'GET',
        url:'/api/quiz/getAllQuestions'
    })
}
export function addQuestions(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'/api/quiz/addQuestions'
    })
}
export function updateQuestion(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'/api/quiz/updateQuestion'
    })
}